import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import numeral from 'numeral';

import Dropdown from '../Dropdown';
import moment from 'moment';

import classNames from 'classnames';
import classes from './ResourceItem.module.scss';
import useCompanyInfo from '../../../hooks/useCompanyInfo';
import DescriptionIcon from '../../../components/Icons/DescriptionIcon';

import aiLogo from '../../../assets/ai_logo.png'

const AiButton = () => {
  return (
    <div className={classes.resourceItem__aiButton}>
      <div>Generate with AI</div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        style={{
          enableBackground: "new 0 0 119.25 122.88",
        }}
        width={32}
        height={32}
        viewBox="0 0 119.25 122.88"
      >
        <path d="M86.28 104.11c-.47-.19-.98-.3-1.52-.3s-1.05.11-1.52.3c-.47.2-.9.48-1.25.84l-.03.02c-.2.2-.39.43-.54.68-.08.13-.16.27-.23.42h-6.31v-5.48a13.64 13.64 0 0 1-3.54 1.1v6.14c0 .49.2.93.52 1.25.32.32.76.52 1.25.52h8.14a3.869 3.869 0 0 0 .69.95l.03.03c.36.36.8.66 1.29.86.47.19.98.3 1.52.3.52 0 1.03-.1 1.49-.29l.03-.01a3.942 3.942 0 0 0 2.15-2.15c.19-.47.3-.98.3-1.52 0-.53-.11-1.04-.3-1.52-.2-.49-.5-.93-.86-1.29-.38-.35-.82-.65-1.31-.85zm-28.85-37.5h-7.4l-1.06 3.48h-6.66l7.95-21.12h7.14l7.92 21.12h-6.83l-1.06-3.48zm-1.38-4.58-2.31-7.59-2.32 7.59h4.63zm11.11-13.07h6.55v21.12h-6.55V48.96zm-4.99-21.65c-1.08.78-2.08 1.83-2.95 3.19-.04.07-.1.13-.17.17-.27.17-.63.09-.8-.17-.87-1.36-1.87-2.41-2.95-3.19a9.449 9.449 0 0 0-3.7-1.63h-.02a10.07 10.07 0 0 0-3.79-.04c-1.31.23-2.58.71-3.72 1.37a12 12 0 0 0-3 2.49c-.82.95-1.48 2.04-1.91 3.21-.07.18-.13.37-.19.57-.05.18-.11.38-.15.58-.05.26-.27.45-.55.46-1.34.2-2.67.69-3.91 1.42-1.26.75-2.43 1.77-3.44 2.99-1 1.22-1.84 2.66-2.44 4.26-.56 1.5-.9 3.15-.97 4.9-.01.23-.01.45-.01.68 0 .21.01.43.01.66.01.19-.07.39-.24.51-.82.59-1.56 1.2-2.22 1.83-.67.65-1.26 1.32-1.77 2.01-.83 1.13-1.44 2.31-1.85 3.5-.43 1.24-.64 2.51-.66 3.76-.01 1.2.15 2.39.49 3.54.34 1.17.86 2.31 1.53 3.37.38.61.81 1.21 1.28 1.77.48.57 1 1.11 1.56 1.62.14.13.22.34.18.54-.16.76-.24 1.51-.27 2.25-.02.76.02 1.51.12 2.24.19 1.34.58 2.62 1.13 3.8.58 1.26 1.34 2.41 2.22 3.42.85.99 1.82 1.85 2.86 2.56 1.05.72 2.16 1.28 3.3 1.67.51.17 1.03.31 1.56.41.5.1 1 .16 1.49.18.27-.01.52.18.58.46a9.95 9.95 0 0 0 1.4 3.32c.69 1.06 1.56 2 2.56 2.78 1.26.98 2.74 1.72 4.3 2.11 1.47.37 3.02.44 4.54.12 1.36-.28 2.68-.86 3.9-1.78 1.12-.85 2.16-1.99 3.03-3.47.05-.09.13-.16.23-.21.28-.15.63-.04.78.24.72 1.34 1.6 2.41 2.58 3.22 1.06.87 2.23 1.46 3.46 1.8 1.57.43 3.21.43 4.8.1 1.7-.35 3.34-1.09 4.75-2.11 1.11-.79 2.09-1.76 2.87-2.86.74-1.03 1.29-2.18 1.61-3.39.04-.23.22-.43.47-.47 1.47-.26 2.92-.87 4.25-1.78s2.54-2.11 3.53-3.54c.91-1.32 1.64-2.84 2.11-4.5.44-1.55.65-3.23.58-5-.02-.2.07-.4.25-.52.86-.59 1.62-1.21 2.3-1.84.69-.66 1.3-1.34 1.82-2.05.8-1.08 1.39-2.2 1.8-3.35.42-1.19.64-2.4.68-3.61.03-1.17-.11-2.33-.41-3.47-.3-1.15-.77-2.26-1.38-3.31l-.02-.02c-.4-.69-.87-1.35-1.39-1.99-.52-.64-1.11-1.24-1.74-1.81a.587.587 0 0 1-.19-.55 13.34 13.34 0 0 0 .2-4.1c-.15-1.39-.52-2.71-1.06-3.94-.57-1.3-1.33-2.5-2.22-3.55-.86-1.02-1.85-1.91-2.91-2.65s-2.19-1.32-3.34-1.71l-.03-.01c-.61-.21-1.23-.36-1.84-.46h-.02c-.6-.1-1.2-.14-1.79-.13a.58.58 0 0 1-.6-.44c-.1-.41-.23-.81-.38-1.2-.16-.4-.34-.79-.55-1.18-.54-1-1.25-1.92-2.08-2.71-.85-.81-1.82-1.5-2.86-2.03-1.07-.54-2.24-.92-3.44-1.09a10.07 10.07 0 0 0-3.46.1c-1.29.31-2.56.84-3.72 1.68zm16.35 11.26c.07-.22.27-.39.52-.41.42-.03.85-.01 1.28.06.44.07.88.18 1.32.33.83.28 1.66.71 2.43 1.25.76.53 1.48 1.18 2.1 1.92l.01.02c.65.77 1.2 1.63 1.61 2.57.39.88.65 1.82.76 2.81a9.377 9.377 0 0 1-.46 4.04l-.01.04a1.95 1.95 0 0 0 .77 2.25l.03.02c.7.52 1.32 1.09 1.86 1.69.56.61 1.04 1.27 1.44 1.95.44.75.78 1.53.99 2.33.22.79.32 1.59.29 2.38-.02.82-.18 1.64-.47 2.45-.28.77-.69 1.53-1.23 2.27l-.01.01c-.49.67-1.11 1.33-1.84 1.96-.7.6-1.51 1.17-2.44 1.72l-.03.02c-.37.21-.64.53-.8.9-.16.37-.21.78-.13 1.18l.01.08c.19 1.53.1 2.99-.21 4.32a11.27 11.27 0 0 1-1.7 3.86c-.59.85-1.27 1.58-2 2.16a7.61 7.61 0 0 1-2.39 1.31h-.01c-.3.09-.63-.08-.72-.38-1.13-3.69-3.08-4.88-6.38-6.58l-.07-.04c-.46-.22-.96-.24-1.41-.1-.45.14-.84.45-1.07.9l-.03.06c-.22.46-.24.96-.1 1.41.15.45.47.85.93 1.09 2.76 1.41 4.8 2.48 4.77 5.94-.01 1.03-.33 2.03-.87 2.93-.57.95-1.39 1.8-2.34 2.49-.97.7-2.06 1.21-3.18 1.46-1.07.25-2.17.26-3.2-.02-1.74-.48-2.87-1.64-3.63-3.05-.72-1.34-1.12-2.9-1.41-4.32-.02-.05-.02-.11-.02-.16 0-.72-.56-1.19-1.29-1.4-.32-.1-.67-.14-1.01-.14-.35 0-.69.05-1.01.14-.72.22-1.28.69-1.28 1.4 0 .05-.01.09-.02.14-.56 2.22-1.37 3.89-2.32 5.09-1.11 1.41-2.41 2.18-3.75 2.46-.98.2-1.99.15-2.95-.1a8.149 8.149 0 0 1-2.81-1.4c-.83-.65-1.52-1.44-2-2.33-.46-.85-.73-1.79-.73-2.75 0-3.64 2.2-4.86 5.11-6.35.46-.24.78-.64.93-1.09.15-.46.12-.97-.11-1.44-.24-.46-.64-.78-1.09-.93-.45-.14-.95-.12-1.41.1l-.03.01c-3.43 1.75-5.48 3.03-6.71 6.84-.07.25-.31.44-.58.43-.34-.01-.68-.05-1.03-.12-.34-.07-.68-.16-1-.28-.81-.28-1.62-.69-2.38-1.21-.75-.52-1.45-1.14-2.07-1.86-.64-.74-1.19-1.57-1.61-2.48a9.67 9.67 0 0 1-.82-2.71v-.02c-.1-.7-.12-1.43-.04-2.18.07-.7.22-1.43.47-2.15l.01-.03c.14-.41.13-.84.01-1.22l-.01-.02c-.13-.4-.39-.75-.75-1l-.02-.02c-.64-.48-1.22-.99-1.73-1.55-.52-.56-.98-1.16-1.36-1.78-.46-.75-.82-1.55-1.06-2.37-.23-.8-.35-1.62-.34-2.46.01-.85.16-1.72.46-2.57.29-.81.71-1.62 1.29-2.41.49-.67 1.09-1.33 1.81-1.96.69-.61 1.47-1.19 2.37-1.74.33-.2.57-.48.73-.8l.01-.03c.16-.33.22-.7.17-1.07-.01-.04-.01-.08-.01-.12v-.02a12.593 12.593 0 0 1-.11-2.14c.05-1.31.3-2.54.71-3.65.44-1.19 1.06-2.26 1.8-3.17.61-.75 1.31-1.38 2.04-1.87.73-.49 1.5-.84 2.29-1.04.3-.09.63.08.72.38.62 1.96 1.4 3.19 2.89 4.58l.06.05c.37.34.85.5 1.32.48.47-.02.93-.21 1.27-.58l.03-.04c.34-.37.5-.85.48-1.32a1.9 1.9 0 0 0-.6-1.3c-1.2-1.11-1.47-1.8-1.83-2.92-.42-1.29-.35-2.55.06-3.67.28-.77.72-1.49 1.28-2.12.55-.63 1.22-1.19 1.96-1.62l.03-.02c.76-.44 1.58-.76 2.43-.92.81-.15 1.64-.16 2.45.01 1.14.24 2.26.84 3.25 1.88.87.91 1.64 2.17 2.25 3.83l.01.02c.21.65.89 1.03 1.69 1.18.36.07.74.09 1.11.07h.01c.38-.02.74-.09 1.08-.2.6-.2 1.07-.52 1.18-.93v-.23c0-1.16.69-2.39 1.64-3.4 1.04-1.1 2.43-1.97 3.6-2.21.74-.15 1.49-.16 2.22-.05.76.12 1.5.36 2.2.71l.06.02a8.2 8.2 0 0 1 1.93 1.36c.56.54 1.04 1.15 1.4 1.82.57 1.05.83 2.25.65 3.52-.16 1.11-.2 1.81-1.13 2.92l-.01.01c-.33.39-.47.88-.43 1.36.04.46.25.91.62 1.23l.06.05c.39.32.87.45 1.34.41.46-.04.91-.25 1.23-.62l.05-.07c.96-1.14 1.27-1.98 1.71-3.42zm21.96 48.94c-.19-.47-.3-.98-.3-1.52s.11-1.05.3-1.52c.2-.47.48-.9.84-1.25l.02-.03c.2-.2.43-.39.68-.54.13-.08.27-.16.42-.23v-6.31h-7.76c.01-.41.01-.82-.01-1.24-.02-.23.08-.46.28-.59.8-.55 1.53-1.12 2.19-1.71h7.06c.49 0 .93.2 1.25.52.32.32.52.76.52 1.25v8.14a3.869 3.869 0 0 1 .95.69l.03.03c.36.36.66.8.86 1.29.19.47.3.98.3 1.52 0 .52-.1 1.02-.29 1.49l-.01.03a3.942 3.942 0 0 1-2.15 2.15c-.47.19-.98.3-1.52.3-.53 0-1.04-.11-1.52-.3-.49-.2-.93-.5-1.29-.86-.35-.38-.65-.82-.85-1.31zm11.24-20.25h-10.55c.18-.39.34-.78.48-1.18.28-.78.48-1.57.6-2.36h9.47c.07-.13.14-.26.22-.39a3.89 3.89 0 0 1 1.81-1.51c.47-.19.98-.3 1.52-.3.52 0 1.02.1 1.49.29l.03.01a3.942 3.942 0 0 1 2.15 2.15c.19.47.3.98.3 1.52 0 .53-.11 1.04-.3 1.52a3.942 3.942 0 0 1-2.15 2.15c-.47.19-.98.3-1.52.3-.52 0-1.02-.1-1.49-.29l-.03-.01c-.49-.2-.92-.5-1.29-.86-.19-.19-.36-.4-.51-.63l-.02-.03c-.07-.12-.14-.25-.21-.38zm3.36-9.68h-13.27c-.34-1.12-.82-2.21-1.42-3.25l-.02-.03c-.05-.09-.1-.17-.15-.26h13.1V42.49a4.063 4.063 0 0 1-.85-.65c-.36-.36-.66-.8-.86-1.29-.19-.47-.3-.98-.3-1.52 0-.53.11-1.05.3-1.52a3.942 3.942 0 0 1 2.15-2.15c.47-.19.98-.3 1.52-.3.53 0 1.04.11 1.52.3a3.942 3.942 0 0 1 2.15 2.15c.19.47.3.98.3 1.52 0 .52-.1 1.02-.29 1.49l-.01.03c-.2.49-.5.92-.86 1.29-.22.22-.48.42-.75.59-.15.09-.32.18-.48.25V55.8c0 .49-.2.93-.52 1.25-.33.33-.77.53-1.26.53zm-13.87-8.54h-4.52c.12-.66.19-1.32.22-1.98.02-.53.02-1.05-.01-1.56h2.54v-5.22c-.14-.07-.27-.14-.4-.23-.24-.15-.46-.33-.67-.54-.36-.36-.66-.8-.86-1.29-.19-.47-.3-.98-.3-1.51s.11-1.04.3-1.52c.2-.47.48-.9.83-1.26l.03-.03c.36-.36.8-.66 1.29-.86.47-.19.98-.3 1.52-.3s1.05.11 1.52.3c.47.2.9.48 1.26.84l.03.02c.36.36.65.78.85 1.26l.01.03c.19.47.3.98.3 1.52 0 .53-.11 1.05-.3 1.52-.2.47-.48.9-.83 1.26l-.03.03c-.19.19-.4.36-.64.52-.12.08-.24.15-.37.21v7.02a1.778 1.778 0 0 1-1.77 1.77zM31.13 18.77c.47.19.98.3 1.52.3s1.05-.11 1.52-.3c.47-.2.9-.48 1.25-.84l.03-.02c.2-.2.39-.43.54-.68.08-.13.16-.27.23-.42h6.31v5.45c1.11-.59 2.31-1.02 3.54-1.27v-5.95c0-.49-.2-.93-.52-1.25a1.76 1.76 0 0 0-1.25-.52h-8.14a3.869 3.869 0 0 0-.69-.95l-.03-.03c-.36-.36-.8-.66-1.29-.86-.47-.19-.98-.3-1.52-.3-.52 0-1.03.1-1.49.29l-.03.01a3.942 3.942 0 0 0-2.15 2.15c-.19.47-.3.98-.3 1.52 0 .53.11 1.04.3 1.52.2.49.5.93.86 1.29.39.36.82.66 1.31.86zM51.39 7.53v13.66c1.18.34 2.33.88 3.41 1.66l.12.09c0-.03.01-.06.01-.09V7.53c.13-.07.26-.14.39-.22.24-.15.46-.33.65-.52.36-.37.66-.8.86-1.29.19-.47.3-.98.3-1.52 0-.52-.1-1.02-.29-1.49l-.01-.03A3.942 3.942 0 0 0 54.68.31c-.47-.19-.98-.3-1.52-.3-.53 0-1.04.11-1.52.3a3.942 3.942 0 0 0-2.15 2.15c-.19.47-.3.98-.3 1.52 0 .52.1 1.02.29 1.49l.01.03c.2.49.5.92.86 1.29.19.19.4.36.63.51l.02.01c.13.08.25.15.39.22zm9.67-3.36v19.98c.48-.49.99-.92 1.51-1.3a10.6 10.6 0 0 1 2.03-1.16V5.93h11.55a4.063 4.063 0 0 0 .65.85c.36.36.8.66 1.29.86.47.19.98.3 1.52.3.53 0 1.05-.11 1.52-.3a3.942 3.942 0 0 0 2.15-2.15c.19-.47.3-.98.3-1.52 0-.53-.11-1.04-.3-1.52-.2-.49-.5-.93-.86-1.29C82.04.8 81.6.5 81.11.3a3.954 3.954 0 0 0-3-.01l-.03.01c-.49.2-.92.5-1.29.86-.22.22-.42.48-.59.75-.09.15-.18.32-.25.48H62.83c-.49 0-.93.2-1.25.52-.32.33-.52.77-.52 1.26zm8.54 13.87v2.74c.36.02.73.05 1.09.11.84.12 1.66.33 2.45.62v-1.69h5.22c.07.14.14.27.23.4.15.24.33.46.54.67.36.36.8.66 1.29.86.47.19.98.3 1.51.3s1.04-.11 1.52-.3c.47-.2.9-.48 1.26-.83l.03-.03c.36-.36.66-.8.86-1.29.19-.47.3-.98.3-1.52s-.11-1.05-.3-1.52c-.2-.47-.48-.9-.84-1.26l-.02-.03c-.36-.36-.78-.65-1.26-.85l-.03-.01c-.47-.19-.98-.3-1.52-.3-.53 0-1.05.11-1.52.3-.47.2-.9.48-1.26.83l-.03.03c-.19.19-.36.4-.52.64-.08.12-.15.24-.21.37h-7.02c-.49 0-.93.2-1.25.52-.32.31-.52.75-.52 1.24zM18.77 35.2c.19.47.3.98.3 1.52s-.11 1.05-.3 1.52c-.2.47-.48.9-.84 1.25l-.02.03c-.2.2-.43.39-.68.54-.13.08-.27.16-.42.23v6.31h6.55v.31c0 .24.01.49.02.75a.65.65 0 0 1-.27.58c-.86.61-1.63 1.25-2.33 1.9h-5.72c-.49 0-.93-.2-1.25-.52a1.76 1.76 0 0 1-.52-1.25v-8.14a3.869 3.869 0 0 1-.95-.69l-.03-.03c-.36-.36-.66-.8-.86-1.29-.19-.47-.3-.98-.3-1.52 0-.52.1-1.02.29-1.49l.01-.03a3.942 3.942 0 0 1 2.15-2.15c.47-.19.98-.3 1.52-.3.53 0 1.04.11 1.52.3.49.2.93.5 1.29.86.34.38.64.82.84 1.31zM7.53 55.45h9.4c-.16.36-.3.73-.43 1.09-.28.81-.48 1.62-.6 2.44H7.53c-.07.13-.14.26-.22.39a3.89 3.89 0 0 1-1.81 1.51c-.47.19-.98.3-1.52.3-.52 0-1.02-.1-1.49-.29l-.03-.01a3.942 3.942 0 0 1-2.15-2.15c-.19-.47-.3-.98-.3-1.52 0-.53.11-1.04.3-1.52a3.942 3.942 0 0 1 2.15-2.15c.47-.19.98-.3 1.52-.3.52 0 1.02.1 1.49.29l.03.01c.49.2.92.5 1.29.86.19.19.36.4.51.63l.02.03.21.39zm-3.36 9.68H16.4c.38 1.21.93 2.38 1.63 3.49v.01l.02.04H5.93v11.55a4.063 4.063 0 0 1 .85.65c.36.36.66.8.86 1.29.19.47.3.98.3 1.52 0 .53-.11 1.05-.3 1.52a3.942 3.942 0 0 1-2.15 2.15c-.47.19-.98.3-1.52.3-.53 0-1.04-.11-1.52-.3-.49-.2-.93-.5-1.29-.86C.8 86.1.5 85.66.3 85.18c-.19-.47-.3-.98-.3-1.52 0-.52.1-1.02.29-1.49l.01-.03c.2-.49.5-.92.86-1.29.22-.22.48-.42.75-.59.15-.09.32-.18.48-.25V66.89c0-.49.2-.93.52-1.25.33-.31.77-.51 1.26-.51zm13.87 8.54h3.3c-.11.66-.17 1.31-.19 1.95-.02.54-.01 1.07.03 1.59h-1.37v5.22c.14.07.27.14.4.23.24.15.46.33.67.54.36.36.66.8.86 1.29.19.47.3.98.3 1.52s-.11 1.04-.3 1.52c-.2.47-.48.9-.83 1.26l-.03.03c-.36.36-.8.66-1.29.86-.47.19-.98.3-1.52.3s-1.05-.11-1.52-.3c-.47-.2-.9-.48-1.26-.84l-.03-.02c-.36-.36-.65-.78-.85-1.26l-.01-.03c-.19-.47-.3-.98-.3-1.52 0-.53.11-1.05.3-1.52.2-.47.48-.9.83-1.26l.03-.03c.19-.19.4-.36.64-.52.12-.08.24-.15.37-.21v-7.02c0-.49.2-.93.52-1.25.32-.34.76-.53 1.25-.53zm47.99 41.68v-13.99c-1.25-.39-2.43-1.02-3.51-1.91l-.02-.02v15.93c-.13.07-.26.14-.39.22-.24.15-.46.33-.65.52-.36.37-.66.8-.86 1.29-.19.47-.3.98-.3 1.52 0 .52.1 1.02.29 1.49l.01.03a3.942 3.942 0 0 0 2.15 2.15c.47.19.98.3 1.52.3.53 0 1.04-.11 1.52-.3a3.942 3.942 0 0 0 2.15-2.15c.19-.47.3-.98.3-1.52 0-.52-.1-1.02-.29-1.49l-.01-.03c-.2-.49-.5-.92-.86-1.29-.19-.19-.4-.36-.63-.51l-.03-.02c-.13-.08-.26-.15-.39-.22zm-9.68 3.36V98.55c-.42.43-.86.81-1.32 1.16-.71.54-1.45.97-2.22 1.31v15.94H41.26a4.063 4.063 0 0 0-.65-.85c-.36-.36-.8-.66-1.29-.86-.47-.19-.98-.3-1.52-.3-.53 0-1.05.11-1.52.3a3.942 3.942 0 0 0-2.15 2.15c-.19.47-.3.98-.3 1.52 0 .53.11 1.04.3 1.52a3.942 3.942 0 0 0 2.15 2.15c.47.19.98.3 1.52.3.52 0 1.02-.1 1.49-.29l.03-.01c.49-.2.92-.5 1.29-.86.22-.22.42-.48.59-.75.09-.15.18-.32.25-.48h13.12c.49 0 .93-.2 1.25-.52.33-.34.53-.78.53-1.27zm-8.54-13.87v-2.91c-.78-.04-1.56-.16-2.32-.35-.41-.1-.82-.23-1.22-.37v1.87h-5.22c-.07-.14-.14-.27-.23-.4-.15-.24-.33-.46-.54-.67-.36-.36-.8-.66-1.29-.86-.47-.19-.98-.3-1.51-.3s-1.04.11-1.52.3c-.47.2-.9.48-1.26.83l-.03.02c-.36.36-.66.8-.86 1.29-.19.47-.3.98-.3 1.52s.11 1.05.3 1.52c.2.47.48.9.84 1.26l.02.03c.36.36.78.65 1.26.85l.03.01c.47.19.98.3 1.52.3.53 0 1.04-.11 1.52-.3.47-.2.9-.48 1.26-.83l.03-.03c.19-.19.36-.4.52-.64.08-.12.15-.24.21-.37h7.02c.49 0 .93-.2 1.25-.52.32-.32.52-.76.52-1.25z" />
      </svg>
    </div>
  )
}

export default ({
  title,
  photo,
  accumulatedHours,
  employeeId,
  templateId,
  withMenu,
  shiftId,
  placeId,
  withAI,
  isPlace,
  note,
  enableCopy,
  onEditShift,
  onCopyShift,
  onDeleteShift,
  onGenerateTimes,
  onClearTimes,
  canClearTimesForShift,
  onGenerateAiEvents,
  onPressNote,
}) => {
  const { t } = useTranslation();
  const { getDateFormat } = useCompanyInfo();
  const dropdownRef = useRef(null);
  const formatDate = getDateFormat({
    'YY.MM.DD': 'yyyy.MM.DD',
    'DD.MM.YY': 'DD.MM.yyyy',
    'MM.DD.YY': 'MM.DD.yyyy',
  });
  const demandClasses = classNames(
    classes.resourceItem__demand,
    {
      [classes.resourceItem__demand_red]: accumulatedHours?.totalHours && accumulatedHours?.actualHours && accumulatedHours?.actualHours < accumulatedHours?.totalHours,
      [classes.resourceItem__demand_gray]: !accumulatedHours?.totalHours || !accumulatedHours?.actualHours,
      [classes.resourceItem__demand_green]: accumulatedHours?.totalHours && accumulatedHours?.actualHours && accumulatedHours?.actualHours === accumulatedHours?.totalHours,
      [classes.resourceItem__demand_orange]: accumulatedHours?.totalHours && accumulatedHours?.actualHours && accumulatedHours?.actualHours > accumulatedHours?.totalHours,
    },
  );

  const demandTip = () => {
    return `
      <table>
        <tr>
          <td>
              <b>${ t('Period') }:</b>
          </td>
          <td>
            ${moment(accumulatedHours?.startPeriod).format(formatDate)} - ${moment(accumulatedHours?.endPeriod).format(formatDate)}
          </td>
        </tr>
        <tr>
          <td>
              <b>${ t('Target time') }:</b>
          </td>
          <td>
            ${numeral(accumulatedHours?.totalHours || 0).format('0.[00]')} ${t('hours')}
          </td>
        </tr>
        <tr>
          <td>
              <b>${ t('Planned time') } (${ t('period') }):</b>
          </td>
          <td>
            ${numeral(accumulatedHours?.actualHours || 0).format('0.[00]')} ${t('hours')}
          </td>
        </tr>
        <tr>
          <td>
              <b>${ t('Registered time') } (${ t('period') }):</b>
          </td>
          <td>
            ${numeral(accumulatedHours?.rigisteredHoursPeriod || 0).format('0.[00]')} ${t('hours')}
          </td>
        </tr>

         ${accumulatedHours?.accumulated_months > 1 ? `
          <tr>
            <td colspan="2"><hr></td>
          </tr>

          <tr>
            <td>
                <b>${ t('Target time') } (${ t('month') }):</b>
            </td>
            <td>
              ${numeral(accumulatedHours?.totalHoursMonth || 0).format('0.[00]')} ${t('hours')}
            </td>
          </tr>
          <tr>
            <td>
                <b>${ t('Planned time') } (${ t('month') }):</b>
            </td>
            <td>
              ${numeral(accumulatedHours?.actualHoursMonth || 0).format('0.[00]')} ${t('hours')}
            </td>
          </tr>
          <tr>
            <td>
                <b>${ t('Registered time') } (${ t('month') }):</b>
            </td>
            <td>
              ${numeral(accumulatedHours?.rigisteredHours || 0).format('0.[00]')} ${t('hours')}
            </td>
          </tr>

        ` : ''}
      </table>
    `
  };

  const isEmpty = title.includes('Empty')

  return (
    <>
      {
        (title.includes('Empty'))
            ? <div className={classes.resourceItem__empty}><span>Empty</span></div>
            : <div style={{flex: 1, overflow: 'hidden', whiteSpace: 'nowrap', marginRight: 15, textOverflow: 'ellipsis'}}>
                {title}
              </div>
      }
      {
        accumulatedHours?.startPeriod && employeeId && !isEmpty && (
          <div
            data-tooltip-id='demand_hours'
            data-tooltip-html={demandTip()}
            className={demandClasses}>
              {
                !accumulatedHours?.actualHours && !accumulatedHours?.totalHours ?
                ('n/a') :
                ((accumulatedHours?.actualHours ? numeral(accumulatedHours?.actualHours).format('0.[00]') : '-')+'/'+(accumulatedHours?.totalHours ? numeral(accumulatedHours?.totalHours).format('0.[00]') : '-'))
              }
          </div>
        )
      }
      {
        isPlace && !isEmpty
          ? <div data-tooltip-id='place_note' data-tooltip-content={note} style={{marginRight: 24, cursor: 'pointer'}} onClick={() => onPressNote(placeId, note)}>
              <DescriptionIcon style={{width: 12, height: 12}} />
            </div>
          : null
      }
      {
        photo && (
          <div
            data-tooltip-id='user_avatar'
            data-tooltip-html={`<div style="width: 100px; height: 100px; border-radius: 50%; overflow: hidden;"><img alt="" style="width: 100%; height: 100%; object-fit: cover;" src="${photo}" /></div>`}
            style={{width: 20, height: 20}}
            className={classes.resourceItem__avatar_trigger}>
            <img alt='' src={photo} />
          </div>
        )
      }
      {
        templateId && shiftId
          ? <div className={classes.resourceItem__template}>A</div>
          : null
      }
      {
        withMenu && (
          <Dropdown ref={dropdownRef} buttonClass={classes.resourceItem__buttonDots}>
            <div className={classes.resourceItem__title}>
              {title}
            </div>
            {
              shiftId && withAI
                ? <Dropdown.ItemMenu
                    title={<AiButton />}
                    onClick={() => {
                      onGenerateAiEvents(shiftId)
                      dropdownRef.current.close()
                    }}
                  />
                : null
            }
            {
              shiftId
                ? <>
                    {
                      canClearTimesForShift && templateId
                        ? <Dropdown.ItemMenu
                            title={t('Clear Work Times')}
                            onClick={() => {
                              onClearTimes(true)
                              dropdownRef.current.close()
                            }}
                          />
                        : templateId
                          ? <Dropdown.ItemMenu
                              title={t('Generate Work Times')}
                              onClick={() => {
                                onGenerateTimes()
                                dropdownRef.current.close()
                              }}
                            />
                          : null
                    }
                    <Dropdown.ItemMenu
                      title={t('Edit Shift')}
                      onClick={onEditShift}
                    />
                    {
                      enableCopy
                        ? <Dropdown.ItemMenu
                            title={t('Copy Shift')}
                            onClick={() => {
                              dropdownRef.current.close()
                              onCopyShift()
                            }}
                          />
                        : null
                    }
                    <Dropdown.ItemMenu
                      title={t('Delete Shift')}
                      onClick={() => {
                        dropdownRef.current.close()
                        onDeleteShift()
                      }}
                      remove
                    />
                  </>
                : onGenerateTimes
                  ? <Dropdown.ItemMenu
                      title={t('Generate Work Times')}
                      onClick={() => {
                        onGenerateTimes()
                        dropdownRef.current.close()
                      }}
                    />
                  : <Dropdown.ItemMenu
                      title={t('Clear Work Times')}
                      onClick={() => {
                        onClearTimes()
                        dropdownRef.current.close()
                      }}
                    />
            }
            <div className={classes.resourceItem__space} />
          </Dropdown>
        )
      }
      {/*<div onClick={addEmployee}>Empty</div>*/}
    </>
  );
};
